import React from "react";
import { Drawer as DrawerPrimitive } from "vaul";
import { breakpointClasses, cn, splitBreakpointProps } from "@/lib/utils";
import type { DrawerDescriptionProps } from "../types";

function DrawerDescription({ className, ...props }: DrawerDescriptionProps) {
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  return (
    <DrawerPrimitive.Description
      data-slot="drawer-description"
      className={cn("text-sm text-muted-foreground", className, classes)}
      {...native}
    />
  );
}

DrawerDescription.displayName = "Drawer.Description";

export default DrawerDescription;
